<script setup>

</script>

<template>

  <div id="page-container">
    <!-- Main Container -->
    <div id="mcp-container">
      <RouterView />
    </div>
    <!-- END Main Container -->
  </div>
</template>

<style>

</style>